import cx from 'classnames';
import { Link } from 'react-router-dom';
import "./OrganizationUserList.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OrganizationUserList(_ref) {
  let {
    arrowRef,
    arrowStyle,
    className,
    innerRef,
    placement,
    users,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: cx('OrganizationUserList', `OrganizationUserList--${placement}`, className),
    ...rest,
    ref: innerRef,
    "data-sentry-component": "OrganizationUserList",
    "data-sentry-source-file": "OrganizationUserList.tsx",
    children: [/*#__PURE__*/_jsx("div", {
      className: "OrganizationUserList__arrow",
      ref: arrowRef,
      style: arrowStyle
    }), /*#__PURE__*/_jsx("ol", {
      className: "OrganizationUserList__list",
      children: users.map(email => /*#__PURE__*/_jsx("div", {
        className: "OrganizationUserList__user",
        children: /*#__PURE__*/_jsx(Link, {
          className: "OrganizationUserList__user-link",
          to: `/users/edit/${encodeURIComponent(email)}`,
          children: email
        })
      }, email))
    })]
  });
}